export default __webpack_public_path__ + "28407cd0db898675cb4c2a2780a72e75.png";